// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__RTR5Q","item":"Breadcrumbs_item__OtMh9","sep":"Breadcrumbs_sep__nFLNL","link":"Breadcrumbs_link__5iPTv","current":"Breadcrumbs_current__NsnyB"};